(ns machtfit.startpage.emarsys
  (:require [machtfit.storage :as storage]
            [machtfit.utils :as utils]
            [machtfit.widgets.icon :as icon]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(defn restore-from-local-storage [db local-storage]
  (let [key 'machtfit.app.startpage.dismissed-campaign-ids
        value (get local-storage key #{})]
    (assoc-in db [:ui :emarsys :dismissed-campaign-ids] value)))

(rf/reg-event-fx ::dismiss-emarsys-content
  (fn [{:keys [db]} [_ campaign-id]]
    (let [dismissed-campaign-ids (-> db :ui :emarsys :dismissed-campaign-ids ((fnil conj #{}) campaign-id))]
      {:db (assoc-in db [:ui :emarsys :dismissed-campaign-ids] dismissed-campaign-ids)
       ::storage/local-storage-put {'machtfit.app.startpage.dismissed-campaign-ids dismissed-campaign-ids}})))

(defn load-campaigns [{:keys [ads]}]
  (group-by :campaign-type
            (mapv (fn [campaign]
                    (let [{:keys [trigger document]} (js->clj (js/JSON.parse (:c_content_v3 campaign)) :keywordize-keys true)
                          campaign-type (first (keys document))
                          campaign-html (-> document campaign-type :content first :html :html)]
                      {:id (:id campaign)
                       :trigger trigger
                       :campaign-url (:c_campaign_url campaign)
                       :campaign-type campaign-type
                       :html campaign-html}))
                  ads)))

(rf/reg-sub ::visible-ribbons
  :<- [:get [:ui :emarsys :dismissed-campaign-ids]]
  :<- [:get [:emarsys-campaigns :ribbon]]
  (fn [[dismissed-campaign-ids ribbons] _]
    (remove #(utils/in? dismissed-campaign-ids (:id %)) ribbons)))

(rf/reg-sub ::visible-overlays
  :<- [:get [:ui :emarsys :dismissed-campaign-ids]]
  :<- [:get [:emarsys-campaigns :overlay]]
  (fn [[dismissed-campaign-ids overlays] _]
    (remove #(utils/in? dismissed-campaign-ids (:id %)) overlays)))

(rf/reg-sub ::first-overlay
  :<- [::visible-overlays]

  (fn [overlays _]
    (when (some? overlays)
      (first overlays))))

(defn campaign-component [_campaign]
  (let [!ref (atom nil)
        ref! (partial reset! !ref)]
    (r/create-class
     {:display-name "campaign-component"

      :component-did-mount
      (fn [this]
        (let [[_ {:keys [html]}] (r/argv this)
              shadow-root (or (.-shadowRoot @!ref)
                              (.attachShadow @!ref #js {:mode "open"}))]
          (set! (.-innerHTML shadow-root) html)
          (when-let [close-btn (.getElementById shadow-root "close")]
            (.remove close-btn))))

      :reagent-render
      (fn [_campaign]
        [:div {:ref ref!}])})))

(defn emarsys-ribbon [{:keys [id] :as campaign}]
  [:div.relative
   {:id id}
   [:div.cursor-pointer.absolute.top-0.right-0.bottom-0.flex.items-center.p-4
    {:on-click #(rf/dispatch [::dismiss-emarsys-content id])}
    [icon/outline "x-close"
     {:stroke "stroke-white"
      :height "h-4"
      :width "w-4"}]]
   [:div.static [campaign-component campaign]]])

(defn emarsys-ribbons []
  (let [ribbons @(rf/subscribe [::visible-ribbons])]
    [:<> (for [ribbon ribbons]
           ^{:key (:id ribbon)}
           [emarsys-ribbon ribbon])]))

(defn emarsys-overlay []
  (let [first-overlay @(rf/subscribe [::first-overlay])]
    (when first-overlay
      [:div.notification-2019
       {:id (:id first-overlay)}
       [:div.absolute.overflow-y-auto
        {:class "top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 max-w-[870px] max-h-full"}
        [:div.cursor-pointer.absolute.top-0.right-0.flex.items-center.p-4
         {:on-click #(rf/dispatch [::dismiss-emarsys-content (:id first-overlay)])}
         [icon/outline "x-close"
          {:stroke "stroke-white"
           :height "h-4"
           :width "w-4"}]]
        [campaign-component first-overlay]]])))

(rf/reg-event-db ::disable-web-channel-content
  (fn [db _]
    (-> db
        (assoc :fetch-emarsys-campaigns? false)
        (dissoc :emarsys-campaigns))))

(defn ^:export disable-web-channel-content []
  (rf/dispatch [::disable-web-channel-content]))

(rf/reg-event-db ::enable-web-channel-content
  (fn [db _]
    (assoc db :fetch-emarsys-campaigns? true :emarsys-campaigns-requested? false)))

(defn ^:export enable-web-channel-content []
  (rf/dispatch [::enable-web-channel-content]))
